var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 2.5,
    stroke: "#254BAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6479 17.1738H13.0481L11.0336 9.28826L9.03643 17.1738H6.4366L3.14808 5.68983H5.88564L7.90008 13.9886L10.0867 5.68983H11.9978L14.1672 13.9886L16.1644 5.68983H18.9192L15.6479 17.1738Z",
    fill: "#254BAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.59ab55bd97d6e6c991e158ec176c50f8.svg";
export { ForwardRef as ReactComponent };